import { fetchAuthSession } from 'aws-amplify/auth';
import { Api, buildQueryString } from '@/common/utils/index';

const basePath = '/registration-codes';

export const getRegistrationCodes = (params) =>
  Api.request({
    url: `${basePath}${buildQueryString(params)}`,
  });

export const getResellers = (params) =>
  Api.request({
    url: `/resellers${buildQueryString(params)}`,
  });

export const generateRegistrationCodes = (payload) =>
  Api.request({
    url: `${basePath}/generate`,
    method: 'post',
    payload,
  });

export const updateRegistrationCodeStatus = (id, payload) =>
  Api.request({
    url: `${basePath}/${id}/status`,
    method: 'put',
    payload,
  });

export const exportRegistrationCodesCsv = async (params) => {
  const token = (await fetchAuthSession()).tokens?.accessToken?.toString();

  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}${basePath}/export/csv${buildQueryString(
      params
    )}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Export registration codes error');
  }

  return response.blob();
};
